/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a constant, not a React component. */
import {
  columnFilteringFeature,
  columnVisibilityFeature,
  createFilteredRowModel,
  createSortedRowModel,
  filterFn_includesString as includesStringFilterFn,
  metaHelper,
  rowExpandingFeature,
  rowSortingFeature,
  sortFn_alphanumeric as alphanumericSortFn,
  tableFeatures,
} from '@tanstack/react-table';

import type { DimeColumnMeta } from '../DimeDataTable/TableFeatures.js';
import type { TableLoadingMeta } from '../table-internals/table-loading-meta.js';

// rowSelectionFeature is deliberately absent — selection is out of scope for the nested table.
export const dimeNestedTableFeatures = tableFeatures({
  rowExpandingFeature,
  rowSortingFeature,
  columnFilteringFeature,
  columnVisibilityFeature,
  sortedRowModel: createSortedRowModel(),
  filteredRowModel: createFilteredRowModel(),
  filterFns: { includesString: includesStringFilterFn },
  sortFns: { alphanumeric: alphanumericSortFn },
  columnMeta: metaHelper<DimeColumnMeta>(),
  tableMeta: metaHelper<TableLoadingMeta>(),
});

export type DimeNestedTableFeatures = typeof dimeNestedTableFeatures;
